export const TEMPLATE_CONVENTION_PREFIX = 'Docs Management -';

export interface Signer {
    id: string;
    type: 'signer';
}

export interface DocumentTemplate {
    id: string;
    name: string;
    description: string;
    signers?: Signer[];
    lastUpdated: string;
}

export interface DocumentTemplateResponse {
    data: DocumentTemplate[];
    total_number_of_templates: number;
}

export interface DocumentTemplatePreviewResponse {
    image: string;
}

export type ImageSizes = 'thumb' | 'small' | 'medium' | 'large' | 'extraLarge';
